<div class="dtf-olp" style="background-color: #E6E6E6;">
    <div class="container_dashboard">
        <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
          <div class="example-button-row">
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
              <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4">Manage Bank Profile</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8" style="background-color: #00566A !important; color: white !important;">Help</mat-button-toggle>
            </mat-button-toggle-group>
            </div>
        </div> 
    </div>

    <div class="container_dashboard">
        <div class="cardlike">
            <h1>Help</h1>
        </div>
        <br><br>
        <div class="card" style="margin-right: 10px;">
            <p style="font-weight: bold;">{{ 'help.subtitle1' | translate }}</p>
            <ul class="custom-list">
                <li>{{ 'help.listpoint1' | translate }}</li>
                <li>{{ 'help.listpoint2' | translate }}</li>
                <li>{{ 'help.listpoint4' | translate }}</li>
            </ul>
            <br>
            <p style="font-weight: bold;">{{ 'help.subtitle2' | translate }}</p>
            <ul class="custom-list">
                <li>{{ 'help.listpoint5' | translate }}</li>
                <li>{{ 'help.listpoint6' | translate }}</li>
                <li>{{ 'help.listpoint7' | translate }}</li>
                <li>{{ 'help.listpoint8' | translate }}</li>
            </ul>
            <br>
            <p style="font-weight: bold;">{{ 'help.subtitle3' | translate }}</p>
            <p>{{ 'help.paragraph1' | translate }}</p>
            <ul class="custom-list">
                <li>{{ 'help.listpoint9' | translate }}</li>
                <li>{{ 'help.listpoint10' | translate }}</li>
                <li>{{ 'help.listpoint11' | translate }}</li>
                <li>{{ 'help.listpoint12' | translate }}</li>
                <li>{{ 'help.listpoint13' | translate }}</li>
            </ul>
        </div>
    </div>
</div>
